var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"dont-print",on:{"click":function($event){return _vm.exportToExcel()}}},[_vm._v("📊Export to Excel")])
}
var staticRenderFns = []

export { render, staticRenderFns }